import React, { Component } from 'react';
import { Nav, NavLink, NavItem } from 'reactstrap';
import PropTypes from 'prop-types';

import './styles.scss';

class Sidebar extends Component {
	constructor(props) {
		super(props);
		let Menues = this.props.Menues;
		this.state = {
			Menues: Menues,
		}
	}

	static propTypes = {
		Menues: PropTypes.array,
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.Menues !== this.props.Menues) {
			this.setState(prevState => {
				prevState.Menues = nextProps.Menues;
				return prevState;
			});
		}
	}


	toggleSidebar(e) {
		if (document.body.classList.contains('sidebar-show'))
			document.body.classList.remove('sidebar-show');
		else
			document.body.classList.add('sidebar-show');
	}

	render() {
		let { Menues } = this.state;
		return (
			<div className="sidebar" onClick={(e) => this.toggleSidebar(e)}>
				<Nav className="">
					<NavItem className="pt-4 px-4 pb-1 nav-item-border-bottom">
						<h1><i className="fa fa-user"></i></h1>
						<div className="row">
							<div className="col-12">
								<a href={"#login"}>Iniciar Sesión</a>
								<div className="d-inline-block px-2">|</div>
								<a href={"#register"}>Registrar</a>
							</div>
						</div>
					</NavItem>
					{Menues.map((x, i) =>
						<NavItem
							key={i}
						>
							<NavLink href={"#" + x.href} className="paradigma-header-menu-button">
								{x.Nombre}
							</NavLink>
						</NavItem>
					)

					}
				</Nav>
			</div>
		)
	}
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js